import { Alert, Box, Snackbar, Tooltip } from "@mui/material";
import {
    ContainerInputNumber,
    InputQauntity,
    TitleDialog,
    useTableLayoutClasses,
    WarningBoxStyled,
} from "../TableLayout.style";
import AppIconButtonInt from "../../../AppButtons/AppIconButtonInt";
import { AppIconsRemove, AppIconsAdd } from "../../../AppIcons";
import { useEffect, useState } from "react";
import { useTranslation } from "../../../../../explorer/hooks/useTranslation";
import { BasketItemDTO } from "../../../../../explorer/types/Basket/BasketItems";
import useBrands from "../../../../../explorer/hooks/useBrands";
import AppIconsError from "../../../AppIcons/AppIconsError";

type TQuantityComponent = {
    item: any;
    additionalProps: any;
};

const QuantityComponent = (props: TQuantityComponent) => {
    const classes = useTableLayoutClasses();

    const [loadPricingTimoutHandler, setLoadPricingTimoutHandler] = useState<
        NodeJS.Timeout | undefined
    >(undefined);
    const [value, setValue] = useState<number | string>(props.item.qty);
    const [error, setError] = useState<boolean>(false);

    const brand = useBrands().currentBrandUrl;
    const { t } = useTranslation();
    const isReadOnly: boolean = (props.additionalProps !== undefined &&  props.additionalProps.readonly !== undefined && props.additionalProps.readonly );

    const handleDecrease = () => {
        // Non può andare sotto 1
        setValue((prevValue) => {
            if (Number(prevValue) <= 1) return 1;
            handleChangeValue(Number(prevValue) - 1);
            return Number(prevValue) - 1;
        });
    };

    const handleIncrese = () => {
        setValue((prevValue) => {
            handleChangeValue(Number(prevValue) + 1);
            return Number(prevValue) + 1;
        });
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        var newValue = e.target.value;

        if (!newValue || Number(newValue) >= 0) {
            setValue(newValue);
            handleChangeValue(Number(newValue));
        }
    };

    const handlePaste = (event: React.ClipboardEvent<HTMLDivElement>) => {
        const re = /^[0-9]+$/;

        if (!re.test(event.clipboardData.getData("text"))) {
            event.preventDefault();
        }
    };

    const handleKeyDown = (
        e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const re = /^[0-9]+$/;

        // Tasti consentiti aggiuntivi
        const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Delete"];

        // Verifica se il tasto premuto è un numero o un tasto consentito
        if (!re.test(e.key) && !allowedKeys.includes(e.key)) {
            e.preventDefault(); // Blocca l'input se non è valido
            return;
        }
    };

    const handleClose = () => {
        setError(false);
    };

    // Al cambio del value, se dopo 3s non è cambiato lo stato, deve chiamare l'API per cambiare la qty.
    const handleChangeValue = (newValue: number) => {
        if (newValue === 0) {
            clearTimeout(loadPricingTimoutHandler);
            return;
        }

        if (loadPricingTimoutHandler !== undefined) {
            clearTimeout(loadPricingTimoutHandler);
        }

        var timeout = setTimeout(function () {
            const basketItem: BasketItemDTO = {
                rowId: props.item.rowId,
                code: props.item.code,
                qty: newValue,
            };

            props.additionalProps.handleChangeQty(basketItem);
        }, 2000);

        setLoadPricingTimoutHandler(timeout);
    };

    useEffect(() => {
        if (props.item.qty) setValue(props.item.qty);
    }, [props.item.qty]);

    return (
        <Box sx={classes.iconCell}>
            <ContainerInputNumber>
                {!isReadOnly ? (
                    <>
                        <Box
                            sx={[
                                { width: 120, display: "flex" },
                                classes.hideOnPrint,
                            ]}
                        >
                            <AppIconButtonInt
                                disabled={
                                    props.additionalProps.loadingPrices ||
                                    props.additionalProps.listDisabledRow.current.includes(
                                        props.item.rowId
                                    )
                                }
                                onClick={handleDecrease}
                            >
                                <AppIconsRemove />
                            </AppIconButtonInt>
                            <InputQauntity
                                value={value}
                                disabled={
                                    props.additionalProps.loadingPrices ||
                                    props.additionalProps.listDisabledRow.current.includes(
                                        props.item.rowId
                                    )
                                }
                                type="number"
                                onChange={handleChange}
                                onKeyDown={handleKeyDown}
                                onPaste={handlePaste}
                            />

                            <AppIconButtonInt
                                disabled={
                                    props.additionalProps.loadingPrices ||
                                    props.additionalProps.listDisabledRow.current.includes(
                                        props.item.rowId
                                    )
                                }
                                onClick={handleIncrese}
                            >
                                <AppIconsAdd />
                            </AppIconButtonInt>
                        </Box>
                        <Box sx={[classes.hideOnPrint]}>
                            {props.item.uom ?? "PCE"}
                        </Box>
                        <Box sx={[classes.showOnPrint]}>
                            {`${props.item.qty} ${props.item.uom ?? "PCE"}`}
                        </Box>
                    </>
                ) : (
                    <> {`${props.item.qty} ${props.item.uom ?? "PCE"}`}</>
                )}
                <WarningBoxStyled>
                    {props.item.warningPackageQty && (
                        <Tooltip
                            children={<AppIconsError color="warning" />}
                            title={`${t("common.basket.warningPackageQty")} (${props.item.packageQuantity})`}
                            placement="top"
                        />
                    )}
                </WarningBoxStyled>
            </ContainerInputNumber>

            <Snackbar
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                open={error}
                key={"error_message"}
                autoHideDuration={3000}
            >
                <Alert
                    onClose={handleClose}
                    severity="error"
                    //variant="filled"
                    sx={{ width: "100%" }}
                >
                    <TitleDialog>{t("alert.title.error")}</TitleDialog>
                    {t("common.basket.errorMessage")}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default QuantityComponent;
